import { render, staticRenderFns } from "./CategoryRoute.vue?vue&type=template&id=243b7606"
import script from "./CategoryRoute.vue?vue&type=script&lang=js"
export * from "./CategoryRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports